// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"4b891baf","299":"674353e2"}[chunkId] + ".js";
};